import {
  LayoutDashboard,
  List,
  Shield,
  Tag,
  UserStar,
  Workflow,
  type NavItemProps,
} from "@repo/ui";
import { cn } from "@repo/utils";
import { routes } from "~/lib/constants";

export const navigationItemLabels = {
  administration: "Administration",
  dashboard: "Dashboard",
} as const;

export const navigationItems: NavItemProps[] = [
  {
    label: navigationItemLabels.administration,
    to: routes.administration.brandSettings,
    icon: ({ isActivePrefix }) => (
      <UserStar
        className={cn("h-5 w-5", {
          "text-blue-600": !isActivePrefix(routes.administration.brandSettings),
          "text-white": isActivePrefix(routes.administration.brandSettings),
        })}
      />
    ),
    onClick: "toggleAdministration",
  },
  {
    label: navigationItemLabels.dashboard,
    to: routes.dashboard.taskManager,
    icon: <LayoutDashboard className="h-5 w-5" />,
    onClick: "toggleDashboard",
  },
];

export const administrationNavItems: NavItemProps[] = [
  {
    label: "Brand Settings",
    to: routes.administration.brandSettings,
    icon: <Tag className="h-5 w-5" />,
  },
  {
    label: "Lists",
    to: routes.administration.lists,
    icon: <List className="h-5 w-5" />,
  },
  {
    label: "Permissions",
    to: routes.administration.permissions,
    icon: <Shield className="h-5 w-5" />,
  },
  {
    label: "Workflows",
    to: routes.administration.workflows,
    icon: <Workflow className="h-5 w-5" />,
  },
] as const;
